import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-hs-apply-now.component.scss';

export class FormItemHsApplyNow extends Base {

	// form
	form: HTMLFormElement;
	steps: HTMLFormElement[];
	survey: HTMLFormElement;

	// form sections
	formLoader: Element;
	formFields: Element;
	formThankyou: Element;
	formSurvey: Element;
	formSurveyMessag: Element;

	// inputs
	applicationType: HTMLFormElement;
	businessFields: HTMLFormElement[];
	jointFields: HTMLFormElement[];
	applicantAdd: HTMLFormElement;
	applicantRem: HTMLFormElement[];

	// buttons
	buttonSubmit: Element;
	stepButtons: Element[];
	surveyButton: Element;

	// wizard count
	wizardCount: Element;
	bulletContainer: Element;
	totalSteps: Element;

	// hidden
	hidLeadId: any;
	hidProduct: any;
	hidCallMeBackModalId: any;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.formLoader = this.element.querySelector(".form__loader--container");
		this.formFields = this.element.querySelector(".form__fields--container");
		this.formThankyou = this.element.querySelector(".form__thankyou--container");
		this.formSurvey = this.element.querySelector(".form__survey--container");
		this.formSurveyMessag = this.element.querySelector(".form__survey--message");

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.steps = Array.from(this.element.querySelectorAll(".hs-apply-now__steps--step[data-step]"));
		this.survey = this.element.querySelector(".form__survey--container");
		this.buttonSubmit = this.element.querySelector('.js_step-submit-button');
		this.stepButtons = Array.from(this.element.querySelectorAll(".js_step-button"));
		this.surveyButton = this.element.querySelector(".js_survey-button");
		this.hidLeadId = this.form.querySelector('input[name=leadId]');
		this.hidProduct = this.form.querySelector('input[name=product]');
		this.wizardCount = this.element.querySelector(".hs-apply-now__counter--count");
		this.bulletContainer = this.element.querySelector(".hs-apply-now__bullets");
		this.applicationType = this.element.querySelector(".js-apply-now-app-type");
		this.businessFields = Array.from(this.element.querySelectorAll(".js-hs-apply-now-vissible-business"));
		this.jointFields = Array.from(this.element.querySelectorAll(".js-hs-apply-now-vissible-joint"));
		this.applicantAdd = this.element.querySelector(".js-hs-apply-now-add-applicant");

		this.totalSteps = this.element.querySelector('input[name="total-steps"]');
		this.totalSteps.nodeValue = this.steps.length.toString();
		this.showStep(1);
		if (this.applicationType) {
			this.updateForm(this.applicationType.value);
		}
	}

	bindEvents() {
		if (this.surveyButton) {
			this.surveyButton.addEventListener('click', (event) => {
				if (this.survey) {
					this.getSurveyQuestions();
				}
			});
		}

		if (this.buttonSubmit) {
			this.buttonSubmit.addEventListener('click', (event) => {
				const formFields: any = this.form.querySelectorAll('input, select, textarea');
				const validation = this.validationService.validate(formFields);
				const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
				if (valid.length == 0) {
					this.actionForm(this.form);
				}
			});
		}

		if (this.stepButtons.length) {
			this.stepButtons.map((item) => item.addEventListener('click', (event) => {
				const _event: any = event.currentTarget;
				const _currentStep = _event.closest(".hs-apply-now__steps--step");
				let _steps = Array.from(this.element.querySelectorAll(".hs-apply-now__steps--step"));
				if (!_currentStep.classList.contains("hs-apply-now__steps--hidden")) {
					const formFields: any = _currentStep.querySelectorAll('input, select, textarea');
					const validation = this.validationService.validate(formFields);
					const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
					if (valid.length == 0) {
						this.showNextStep(event);
					}
				}
			}));
		}

		if (this.applicationType) {
			this.applicationType.addEventListener('change', (event) => {
				this.updateForm(this.applicationType.value);
			});
		}

		if (this.applicantAdd) {
			this.applicantAdd.addEventListener('click', (event) => {
				this.addCoApplicant();
			});
		}

		// Reset the form
		this.form.addEventListener('custom_form_reset_event', (e) => {
			this.showStep(1);
			this.formSurvey.innerHTML = "";
			this.formSurvey.classList.remove("active");
			this.formSurveyMessag.classList.remove('active');
			let _formName: any = this.form.getAttribute("data-frmcontainer");
			_formName = _formName.replace(" survey");
			this.form.setAttribute("data-frmcontainer", _formName);
		}, false);
	}

	showStep(stepId) {
		const _listItems = document.createElement('ul');
		_listItems.classList.add("hs-apply-now__bullets-container");

		if (this.steps) {
			this.steps.forEach((element, index) => {
				const _step = element.getAttribute("data-step");
				const _listItem = document.createElement('li');
				if ((parseFloat(_step) == stepId)) {
					element.classList.remove("hs-apply-now__steps--hidden");
					_listItem.classList.add("hs-apply-now__bullets-container--bullet-active");
				} else {
					element.classList.add("hs-apply-now__steps--hidden");
					_listItem.classList.add("hs-apply-now__bullets-container--bullet");
				}
				_listItem.innerHTML = "&bull;";

				_listItems.appendChild(_listItem);

				if (index < (this.steps.length - 1)) {
					const _listPipe = document.createElement('li');
					_listPipe.classList.add("hs-apply-now__bullets-container--bullet");
					_listPipe.innerHTML = "|";
					_listItems.appendChild(_listPipe);
				}
			});
		}
		this.wizardCount.innerHTML = stepId + "/" + parseFloat(this.totalSteps.getAttribute('value'));
		this.bulletContainer.innerHTML = "";
		this.bulletContainer.appendChild(_listItems);
		this.updateForm(this.applicationType.value);
	}

	showNextStep(event) {
		const _target = event.currentTarget;
		const _currentStep = _target.closest("[data-step]");
		const _nextStep = _currentStep.getAttribute("data-step");
		this.wizardCount.innerHTML = parseFloat(_nextStep) + 1 + "/" + parseFloat(this.totalSteps.getAttribute('value'));
		this.showStep(parseFloat(_nextStep) + 1);
	}

	updateForm(type) {
		if (this.businessFields) {
			this.businessFields.forEach(elem => {
				const _group = elem.closest(".form__group ");
				if (type == 'B') {
					elem.classList.add("form__input--required");
					_group.classList.remove("form__group--hidden");
				} else {
					elem.classList.remove("form__input--required");
					_group.classList.add('form__group--hidden');
				}
			});
		}

		if (this.jointFields) {
			this.jointFields.forEach(elem => {
				const _group = elem.closest(".form__group");
				if (type == 'J') {
					elem.classList.add("form__input--required");
					_group.classList.remove("form__group--hidden");
				} else {
					elem.classList.remove("form__input--required");
					_group.classList.add('form__group--hidden');
				}
			});
		}

		if (type != 'J') {
			this.applicantAdd.classList.remove('link--disabled');
			let _coAppParent = this.element.querySelector(".form__coapp--parent");
			if (_coAppParent) {
				_coAppParent.remove();
			}
		}
	}

	addCoApplicant() {
		let _parentExists: boolean = false;
		let _childCount = false;

		const _parent = this.applicantAdd.closest(".form__group");
		let _coAppParent = this.element.querySelector(".form__coapp--parent");
		if (!_coAppParent) {
			_coAppParent = document.createElement("div");
			_coAppParent.classList.add("form__coapp--parent");

			_parentExists = true;
			_childCount = true;
		} else {
			_parentExists = true;
			let _coAppChild = Array.from(this.element.querySelectorAll(".form__coapp--child"));
			if (_coAppChild.length < 5) {
				_childCount = true;
			} else {
				_childCount = false;
			}
		}

		if (_parentExists && _childCount) {
			const _guid = this.guidGenerator();
			let _coApplicantChild = document.createElement("div");
			_coApplicantChild.classList.add("form__coapp--child");
			_coApplicantChild.setAttribute("data-coapp", _guid);


			const _name = this.createElement('text', 'first-name', 'Co-App First Name', ['form__input--required']);
			const _surname = this.createElement('text', 'last-name', 'Co-App Surname', ['form__input--required']);
			const _identityNumber = this.createElement('text', 'identification-number', 'Co-App Identity number', ['form__input--required', 'form__input--identification']);
			const _contactNumber = this.createElement('text', 'contact-details', 'Co-App Contact details', ['form__input--required', 'form__input--contact']);
			const _remApplicant = this.createElement('link', 'removeApp', '<span class="link__text" data-modal=""> - Remove Co-Applicant </span>', ['js-hs-apply-now-rem-applicant']);

			_coApplicantChild.appendChild(_name);
			_coApplicantChild.appendChild(_surname);
			_coApplicantChild.appendChild(_identityNumber);
			_coApplicantChild.appendChild(_contactNumber);
			_coApplicantChild.appendChild(_remApplicant);

			_coAppParent.appendChild(_coApplicantChild);
			_parent.append(_coAppParent);
		}

		let _coAppChild = Array.from(this.element.querySelectorAll(".form__coapp--child"));
		if (_coAppChild.length < 5) {
			this.applicantAdd.classList.remove('link--disabled');
		} else {
			this.applicantAdd.classList.add('link--disabled');
		}
	}

	remCoApplicant(event) {
		let _children = Array.from(this.element.querySelectorAll(".form__coapp--child"));
		if (_children.length > 1) {
			let _target = event.currentTarget.closest(".form__coapp--child");
			_target.remove();
		} else {
			let _parent = this.element.querySelector(".form__coapp--parent");
			_parent.remove();
		}
		this.applicantAdd.classList.remove('link--disabled');
	}

	createElement(type, inputName, label, modifiers) {
		const _div = document.createElement('div');
		_div.classList.add("form__group");

		let _input;

		if (type == 'text') {
			const _label = document.createElement("label");
			_label.classList.add("form__label");
			_label.innerText = label;

			_input = document.createElement("input")
			_input.type = type;
			_input.name = inputName;
			_input.classList.add("form__input");
			_input.classList.add(...modifiers);

			_div.appendChild(_label);
			_div.appendChild(_input);
		} else if (type == 'link') {
			const _wrapper = document.createElement('div');
			_wrapper.classList.add("form__link");
			_wrapper.classList.add("hs-apply-now__form-link");

			_input = document.createElement("a")
			_input.href = 'javascript:void(0);';
			_input.setAttribute("data-id", "link_content_apply now remove applicant");
			_input.setAttribute("data-text", "home services | apply now | remove co-applicant button click");
			_input.classList.add("link");
			_input.innerHTML = label;
			_input.classList.add(modifiers);

			_wrapper.appendChild(_input);
			_div.appendChild(_wrapper);

			_input.addEventListener('click', (event) => {
				this.remCoApplicant(event);
			});
		}

		return _div;
	}

	guidGenerator() {
		var S4 = function () {
			return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
		};
		return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
	}

	actionForm(form: HTMLFormElement) {

		let _records = [];

		let name = Array.from(form.querySelectorAll('.form__success-container__firstname'));

		// paremeters
		let _type: any = this.form.querySelector('select[name=applyType]');
		let _address: any = this.form.querySelector('input[name=address]');
		let _city: any = this.form.querySelector('input[name=city]');
		let _suburb: any = this.form.querySelector('input[name=suburb]');
		let _areaCode: any = this.form.querySelector('input[name=areaCode]');
		let _loanAmount: any = this.form.querySelector('input[name=loanAmount]');
		let _businessName: any = this.form.querySelector('input[name=businessName]');
		let _businessRegNumber: any = this.form.querySelector('input[name=businessRegNumber]');
		let _selfEmployed: any = this.form.querySelector('select[name=self-employed]');
		let _newOrFurther: any = this.form.querySelector('select[name=loan-type]');
		let _name: any = this.form.querySelector('input[name=firstName]');
		let _surname: any = this.form.querySelector('input[name=lastName]');
		let _idNumber: any = this.form.querySelector('input[name=identificationNumber]');
		let _contactNumber: any = this.form.querySelector('input[name=contactDetails]');

		_records.push({
			"firstName": _name.value,
			"lastName": _surname.value,
			"identificationNumber": _idNumber.value,
			"contactDetails": _contactNumber.value,
			"consent": "Y",
			"declaration": "Y"
		});

		let _coAppParent = this.element.querySelector(".form__coapp--parent");
		if (_coAppParent && (_type.value == 'J')) {
			let _coApps = Array.from(this.element.querySelectorAll('.form__coapp--child'));
			if (_coApps.length) {
				_coApps.forEach(coApp => {
					let _name: any = coApp.querySelector('input[name=first-name]');
					let _surname: any = coApp.querySelector('input[name=last-name]');
					let _idNumber: any = coApp.querySelector('input[name=identification-number]');
					let _contactNumber: any = coApp.querySelector('input[name=contact-details]');
					_records.push({
						"firstName": _name.value,
						"lastName": _surname.value,
						"identificationNumber": _idNumber.value,
						"contactDetails": _contactNumber.value,
						"consent": "",
						"declaration": ""
					});
				});
			}

		}

		let _form = {
			"applyType": _type.value,
			"selfEmployed": _selfEmployed.value,
			"newOrFurther": _newOrFurther.value,
			"address": _address.value,
			"city": _city.value,
			"suburb": _suburb.value,
			"areaCode": _areaCode.value,
			"loanAmount": _loanAmount.value,
			"businessName": _businessName.value,
			"businessRegNumber": _businessRegNumber.value,
			"recordCount": _records.length,
			"records": _records
		};

		let postData = '';

		postData += 'actionname=applynow&';
		postData += 'applyNowformJSONData=' + JSON.stringify(_form);

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		this.formLoader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/homeservices/sbhsapplynow";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			this.formLoader.classList.remove('active');
			if (!response.data) {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				this.formLoader.classList.remove('active');
				fieldsContainer.classList.remove('hidden');
			} else {
				name.map((_item) => {
					_item.innerHTML = _name.value;
				});
				analyticsService.dtmFormComplete('complete', response.code);
				this.formLoader.classList.remove('active');
				this.formThankyou.classList.add('active');
			}
		}).catch(response => {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			this.formLoader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}
	questions: any = [];
	getSurveyQuestions() {
		let _formName = this.form.getAttribute("data-frmcontainer");
		this.form.setAttribute("data-frmcontainer", _formName + " survey");
		this.analyticsService.dtmRestartForm();
		// loader + hide form
		this.formLoader.classList.add('active');
		this.formLoader.classList.remove('hidden');
		this.formThankyou.classList.add('hidden');
		this.formThankyou.classList.remove('active');

		let postData = 'actionname=getQuestionsWithSurveyId' + '&' + 'applySurveyformJSONData=Y' + '&' + 'srvNo=1';

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/homeservices/sbhsapplysurvey";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			this.formLoader.classList.remove('active');
			if (!response.data || (response.data.code != '0000')) {
				this.formLoader.classList.remove('active');
				this.formThankyou.classList.remove('hidden');
				this.formThankyou.classList.add('active');
			} else {
				this.questions = response.data.questions;
				this.createSurvey(response.data.questions);
				this.formLoader.classList.remove('active');
				this.formSurvey.classList.add('active');
				this.formSurvey.setAttribute("data-survey", response.data.apsrvId);
				this.formSurvey.setAttribute("data-surveyNo", "1");
				this.formSurvey.setAttribute("data-surveyId", response.data["tran-id"]);
			}
		}).catch(response => {
			// service failed
			this.formLoader.classList.remove('active');
			this.formThankyou.classList.remove('hidden');
			this.formThankyou.classList.add('active');
		});
	}

	createSurvey(questions) {
		if (questions && questions != undefined) {
			questions.forEach(question => {
				let _element: Element = null;
				if (question.type == 1) {
					_element = this.createRadioButton(question);
				} else if (question.type == 2) {
					_element = this.createTextField(question);
				}
				if (_element) {
					this.formSurvey.appendChild(_element);
				}
			});

			this.formSurvey.appendChild(this.createButton());
		}
	}

	createRadioButton(object) {
		let _group = document.createElement('div');
		_group.classList.add("form__group");
		_group.setAttribute("data-question", object.questionCode);

		let _wrapper = document.createElement('div');
		_wrapper.classList.add('apply-now__radio');

		let _radioLabel = document.createElement("label");
		_radioLabel.classList.add("form__label");
		_radioLabel.innerText = object.label;
		_wrapper.appendChild(_radioLabel);

		// object.group.forEach(_element => {
		let _label1 = document.createElement("label");
		_label1.classList.add("form__control", "form__control--radio");
		_label1.innerText = "Yes";

		let _radio1 = document.createElement("input");
		_radio1.setAttribute("type", "radio");
		_radio1.setAttribute("name", object.name);
		_radio1.setAttribute("value", "Y");
		_radio1.addEventListener('change', (event) => {
			const _input: any = event.currentTarget;
			let name = _radio1.getAttribute("name");
			let div: Element = this.element.querySelector("[name=" + name + "-textdiv]");
			if (object.condition == 1) {
				div.classList.remove("form__group--hidden")
			} else {
				div.classList.add("form__group--hidden")
			}
		});
		let _indicator1 = document.createElement('div');
		_indicator1.classList.add("form__control-indicator");

		_label1.appendChild(_radio1);
		_label1.appendChild(_indicator1);
		_wrapper.appendChild(_label1);
		// });

		let _label2 = document.createElement("label");
		_label2.classList.add("form__control", "form__control--radio");
		_label2.innerText = "No";
		let _radio2 = document.createElement("input");
		_radio2.setAttribute("type", "radio");
		_radio2.setAttribute("name", object.name);
		_radio2.setAttribute("value", "N");
		_radio2.addEventListener('change', (event) => {
			const _input: any = event.currentTarget;
			let name = _radio2.getAttribute("name");
			let div: Element = this.element.querySelector("[name=" + name + "-textdiv]");

			if (object.condition == 2) {
				div.classList.remove("form__group--hidden");

			} else {
				div.classList.add("form__group--hidden");
			}
		});
		let _indicator2 = document.createElement('div');
		_indicator2.classList.add("form__control-indicator");

		_label2.appendChild(_radio2);
		_label2.appendChild(_indicator2);
		_wrapper.appendChild(_label2);

		let _whygroup = document.createElement('div');
		_whygroup.classList.add("form__group");
		_whygroup.setAttribute("name", object.name + "-textdiv");
		let _label = document.createElement("label");
		_label.classList.add("form__label");
		_label.innerText = object.caseQuestion;

		let _textBox = document.createElement("input");
		_textBox.classList.add("form__input", "form__input--required");
		_textBox.setAttribute("type", "text");
		_textBox.setAttribute("name", object.name + "-text");
		_textBox.setAttribute("value", "");

		_label.appendChild(_textBox);
		_whygroup.appendChild(_label);
		_whygroup.classList.add('form__group--hidden');
		_group.appendChild(_wrapper);
		_group.appendChild(_whygroup)
		return _group;
	}

	createTextField(object) {
		let _group = document.createElement('div');
		_group.classList.add("form__group");
		_group.setAttribute("data-question", object.questionCode);

		let _wrapper = document.createElement('div');
		_wrapper.classList.add('apply-now__radio');

		let _label = document.createElement("label");
		_label.classList.add("form__label");
		_label.innerText = object.label;

		let _textBox = document.createElement("input");
		_textBox.classList.add("form__input", "form__input--required");
		_textBox.setAttribute("type", "text");
		_textBox.setAttribute("name", object.name);
		_textBox.setAttribute("value", "");
		// _textBox.setAttribute("placeholder", object.placeholder);

		_label.appendChild(_textBox);
		_wrapper.appendChild(_label);
		_group.appendChild(_wrapper);

		return _group;
	}

	createButton() {
		let _wrapper = document.createElement('div');
		_wrapper.classList.add("apply-now__buttons");

		let _button = document.createElement("button");
		_button.classList.add("button", "button--medium", "apply-now__button", "js_survey-button");
		_button.setAttribute("type", "button");
		_button.setAttribute("data-id", "link_content_survey button");
		_button.setAttribute("data-text", "home services | apply now | survey submit button click");
		_button.innerText = "Submit";

		_button.addEventListener('click', (event) => {
			this.submitSurveyQuestions(event);
		});

		_wrapper.appendChild(_button);

		return _wrapper;
	}

	submitSurveyQuestions(object) {
		let _answers = [];
		if (this.questions && this.questions != undefined) {
			this.questions.forEach(question => {
				// let inputElement: Element = this.element.querySelector("[name=" + question.name + "]")as HTMLFormElement;
				if (question.type == 1) {
					let inputElement: any = this.formSurvey.querySelector("input[name=" + question.name + "]:checked");
					let answer = "";
					if (inputElement != null) {
						answer = inputElement.value;
						let inputElement1: any = this.formSurvey.querySelector("input[name=" + question.name + "-text]");
						let comment = "";
						if (inputElement1 != null) {
							comment = inputElement1.value;
						}
						_answers.push({
							"answer": answer,
							"questionCode": question.questionCode,
							"comment": comment
						});
					} else {
						_answers.push({
							"answer": "",
							"comment": "",
							"questionCode": question.questionCode
						});
					}
				} else if (question.type == 2) {
					let inputElement: any = this.formSurvey.querySelector("input[name=" + question.name + "]");
					let answer = "";
					if (inputElement != null) {
						answer = inputElement.value;
					}
					_answers.push({
						"answer": answer,
						"questionCode": question.questionCode,
						"comment": answer

					});
				}
			});
		}
		let data = {
			"aplsrvId": this.formSurvey.getAttribute("data-survey"),
			"srvNo": this.formSurvey.getAttribute("data-surveyNo"),
			"reqVisitorId": this.analyticsService.getDtmVisitorID(),
			"reqTranId": this.formSurvey.getAttribute("data-surveyId"),
			"reqFeature": "",
			"ansCount": _answers.length,
			"answersArray": _answers
		}
		let postData = 'actionname=postAnswers' + '&' + 'applySurveyformJSONData=' + JSON.stringify(data);

		let url = "/homeservices/sbhsapplysurvey";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			this.formLoader.classList.remove('active');
			this.formSurvey.classList.remove('active');
			this.formSurveyMessag.classList.add('active');
			if (!response.data || (response.data.code != '0000')) {
				this.analyticsService.dtmFormComplete('complete', response['tran-id']);
			} else {
				this.analyticsService.dtmFormComplete('complete', 'fail');
			}
		}).catch(response => {
			// service failed
			this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
			this.formLoader.classList.remove('active');
			this.formSurvey.classList.remove('active');
			this.formSurveyMessag.classList.add('active');
		});
	}
}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-hs-apply-now/form-item-hs-apply-now.component.ts